import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import ModernCarousel from '../carousel/ModernCarousel';
import styles from './classes.module.css';

const Studio = ({ id, header, para, collection, requireHeading, align, requirements }) => {
    let list = requirements ? requirements.split(".").filter(item => item.trim() !== "") : [];

    // Trigger animations when elements come into view
    const { ref, inView } = useInView({
        threshold: 0.2, // Trigger when 20% of element is visible
        triggerOnce: true
    });

    const isRightAligned = align === "right";

    // Animation variants
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: { staggerChildren: 0.2 }
        }
    };

    const textVariants = {
        hidden: { opacity: 0, x: isRightAligned ? 50 : -50 },
        visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: "easeOut" } }
    };

    const carouselVariants = {
        hidden: { opacity: 0, scale: 0.9, x: isRightAligned ? -30 : 30 },
        visible: { opacity: 1, scale: 1, x: 0, transition: { duration: 0.8, ease: "easeOut" } }
    };

    return (
        <section className={`${styles.studioSection} ${isRightAligned ? styles.alignRight : styles.alignLeft}`} id={id}>
            <div className={styles.studioContainer} ref={ref}>

                {/* Content Side */}
                <motion.div
                    className={styles.textContent}
                    variants={containerVariants}
                    initial="hidden"
                    animate={inView ? "visible" : "hidden"}
                >
                    <motion.h3 variants={textVariants} className={styles.headerTitle}>
                        {header}
                    </motion.h3>
                    <motion.p variants={textVariants} className={styles.paragraph}>
                        {para}
                    </motion.p>

                    {requireHeading && (
                        <motion.div variants={textVariants} className={styles.requirementsBox}>
                            <h4>{requireHeading}</h4>
                            <ul className={styles.requirementList}>
                                {list.map((item, index) => (
                                    <li key={index}>
                                        <span className={styles.bullet}></span>
                                        {item.trim()}
                                    </li>
                                ))}
                            </ul>
                        </motion.div>
                    )}
                </motion.div>

                {/* Carousel/Image Side */}
                <motion.div
                    className={styles.carouselContent}
                    variants={carouselVariants}
                    initial="hidden"
                    animate={inView ? "visible" : "hidden"}
                >
                    <div className={styles.carouselWrapper}>
                        <ModernCarousel items={collection} />
                    </div>
                </motion.div>

            </div>
        </section>
    );
};

export default Studio;